import { TypeFiesta, TypeInsignia } from '@at/design-system-foundation'
import React from 'react'
import { ActionWrapper, MessageWrapper, StyledPostcode } from '../info-banner/info-banner.styles'
import { StyledTertiaryButton } from '../../patterns/search-facets/search-facets.styles'
import { Button } from '@at/design-system-elements/'
import { SearchFiltersPostCodeInput as Postcode } from '../search-filters-postcode-input/search-filters-postcode-input'
import {
    PostcodeErrorBannerWrapper,
    PostcodeErrorBannerWrapperModal,
    TPFLocationCheckboxContainer,
} from './postcode-error.styles'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { Location } from '../search-filters-location/location'
import { isTpf } from '@at/formatter-utils'
import { useIsLeasingSearch } from '../../utils/is-leasing-search'
import { useChannel } from '../../hooks/use-abtest.hook'

const PostcodeErrorMessageModal = () => {
    const handleButtonClick = () => {
        document.getElementById('postcode')?.focus()
    }

    return (
        <PostcodeErrorBannerWrapperModal>
            <MessageWrapper>
                <TypeInsignia as="h3" weight="400">
                    Please enter a postcode
                </TypeInsignia>
                <TypeFiesta as="p">We need a valid postcode so we can show you the best results</TypeFiesta>
            </MessageWrapper>
            <ActionWrapper>
                <StyledTertiaryButton
                    displayType="tertiary"
                    text="Enter postcode"
                    type="button"
                    onInteraction={handleButtonClick}
                    $isMobile={true}
                    underline={true}
                />
            </ActionWrapper>
        </PostcodeErrorBannerWrapperModal>
    )
}

const PostcodeErrorMessage = () => {
    const handleButtonClick = () => {
        document.getElementById('postcode')?.focus()
    }

    const channel = useChannel()

    return (
        <PostcodeErrorBannerWrapper>
            <MessageWrapper>
                <TypeInsignia as="h3" weight="400">
                    Please enter a postcode to see your results
                </TypeInsignia>
                <TypeFiesta as="p">It helps us make sure we’re showing you the most relevant vehicles</TypeFiesta>
            </MessageWrapper>
            <ActionWrapper>
                <StyledPostcode>
                    <Postcode title="Postcode" hideLabel={true} />
                </StyledPostcode>
                {isTpf(channel) && (
                    <TPFLocationCheckboxContainer>
                        <Location />
                    </TPFLocationCheckboxContainer>
                )}
                <Button displayType="secondary" text="Show results" type="button" onInteraction={handleButtonClick} />
            </ActionWrapper>
        </PostcodeErrorBannerWrapper>
    )
}

export const PostcodeError = () => {
    const { showSearchFilter } = useSearchViewState()
    const isLeasingSearch = useIsLeasingSearch()

    if (isLeasingSearch) {
        return null
    }

    return showSearchFilter ? <PostcodeErrorMessageModal /> : <PostcodeErrorMessage />
}
